import TabsRouting from '@components/tabs-routing'
import { TabsContainer } from '@components/tabs-routing/index.styles'
import { ROUTES } from '@core/config/routing'
import { Outlet } from 'react-router-dom'

const tabList = [
    {
        id: 'external-assets-tab-domains',
        tabTitle: ROUTES.external_assets.children.domains.displayName,
        path: ROUTES.external_assets.children.domains.path,
    },
    {
        id: 'external-assets-tab-technologies',
        tabTitle: ROUTES.external_assets.children.technologies.displayName,
        path: ROUTES.external_assets.children.technologies.path,
    },
]

const AMSAssetsRoute = () => {
    return (
        <>
            <TabsContainer>
                <TabsRouting
                    tabList={tabList}
                    tabsName="external-assets-tab"
                />
            </TabsContainer>
            <Outlet />
        </>
    )
}

export default AMSAssetsRoute
